import { render } from "./MMAssessment.vue?vue&type=template&id=f19888d8"
import script from "./MMAssessment.vue?vue&type=script&lang=js"
export * from "./MMAssessment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__